import React, { useEffect, useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { getSettingsDetails } from "../../services/settingsServices";
import {
  createPartVideo,
  deletePartvideo,
  getPartVideoSortDetails,
  updatePartVideoSort,
} from "../../services/PartsInventory";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useNavigate } from "react-router-dom";

const SortableItem = SortableElement(({ video }) => {
  const videoSrc =
    video?.url ||
    (video?.file instanceof File ? URL.createObjectURL(video.file) : null);

  return (
    <div className="m-2 p-2 bg-light border rounded d-flex align-items-center">
      <span className="me-2">☰</span>
      {videoSrc ? (
        <video width="150" controls>
          <source src={videoSrc} type={video?.type || "video/mp4"} />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="text-danger">Invalid video</div>
      )}
    </div>
  );
});

const SortableList = SortableContainer(({ videos }) => (
  <div className="d-flex flex-wrap">
    {videos?.map((video, index) => (
      <SortableItem key={`item-${index}`} index={index} video={video} />
    ))}
  </div>
));

const AddPartVideo = ({
  // currentPart,
  vehicleAddDetails,
  setCurrentStep,
  currentPartVideoIndex,
  setPartVideoDataList,
  detailsForVideo,
  partsData,
  setCurrentPartVideoIndex,
  getFieldPermission,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [videos, setVideos] = useState({});
  const fileInputRefs = useRef({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDelete, setIsModalDelete] = useState(false);
  const [videoDataId, setvideoDataId] = useState("");

  const [settingDetails, setSettingDetails] = useState("");
  const [partImageDetails, setPartImageDetails] = useState("");

  const [btnLoader, setbtnLoading] = useState(false);
  const [btnLoaderNext, setbtnLoadingNext] = useState(false);

  const [showSkip, setShowSkip] = useState(false);

  const currentPart = Array.isArray(detailsForVideo)
    ? detailsForVideo[currentPartVideoIndex]
    : null;

  const partId = currentPart?.id ? currentPart?.id : vehicleAddDetails?.id;
  const isLastPart = currentPartVideoIndex === detailsForVideo?.length - 1;
  const handleNext = () => {
    setShowSkip(true);
  };

  const handleSkip = () => {
    if (currentPartVideoIndex < detailsForVideo.length - 1) {
      setCurrentPartVideoIndex((prev) => prev + 1);
      setShowSkip(false);
    }
  };

  const handleCloseSkip = () => {
    setShowSkip(false);
  };

  const handleFinishFinal = () => {
    const partCatalogId =
      currentPart?.part_catelog ?? vehicleAddDetails?.part_catelog;

    const currentPartUpdated = partsData.find(
      (part) => part.id === partCatalogId
    );
    if (
      Array.isArray(currentPartUpdated?.parts_damage) &&
      currentPartUpdated.parts_damage.length > 0
    ) {
      setCurrentStep(6);
    } else {
      navigate("/parts-inventory");
    }
  };

  const handleSort = (partId, oldIndex, newIndex) => {
    const updatedVideos = arrayMoveImmutable(
      videos[partId] || [],
      oldIndex,
      newIndex
    );
    setVideos((prev) => ({
      ...prev,
      [partId]: updatedVideos,
    }));
  };

  const handleBackVideo = () => {
    const hasDamageInDetails = partsData?.some(
      (item) => item?.parts_damage?.length > 0
    );

    const hasDamageInVehicle = vehicleAddDetails?.parts_damage?.length > 0;
    if (hasDamageInDetails || hasDamageInVehicle) {
      setCurrentStep(4);
    } else if (partsData?.map((item) => item?.parts_damage?.length < 0)) {
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
    }
  };

  useEffect(() => {
    if (vehicleAddDetails?.id) {
      let data = {
        id: vehicleAddDetails.id,
      };

      getPartVideoSortDetails(data)
        .then((response) => {
          setPartImageDetails(response.data.data);
        })
        .catch((err) => {});
    }
  }, [vehicleAddDetails]);

  useEffect(() => {
    if (Array.isArray(partImageDetails)) {
      const grouped = {};

      partImageDetails.forEach((document) => {
        const partId = document.part_id;
        if (!grouped[partId]) {
          grouped[partId] = [];
        }

        grouped[partId].push({
          url: document.video_url,
          id: document.id,
          sequence: document.sort_order,
          part_id: document.part_id,
        });
      });

      setVideos(grouped);
    }
  }, [partImageDetails]);

  const handleDeleteClose = () => {
    setIsModalDelete(false);
  };

  useEffect(() => {
    getSettingsDetails()
      .then((response) => {
        setSettingDetails(response.data.data);
      })
      .catch((err) => {});
  }, []);

  // const handleFileChange = (event, partId) => {
  //   const files = Array.from(event.target.files).map((file, index) => ({
  //     file,
  //     id: 0,
  //     sequence: (videos[partId]?.length || 0) + index + 1,
  //   }));

  //   setVideos((prev) => ({
  //     ...prev,
  //     [partId]: [...(prev[partId] || []), ...files],
  //   }));
  // };

  // const handleRemoveVideo = (partId, index, id) => {
  //   if (id) {
  //     setvideoDataId(id);
  //     setIsModalDelete(true);
  //     setDeleteIndex(index);
  //     setDeletePartId(partId);
  //   } else {
  //     setVideos((prev) => {
  //       const updated = [...(prev[partId] || [])];
  //       updated.splice(index, 1);
  //       return { ...prev, [partId]: updated };
  //     });
  //     if (
  //       (videos[partId]?.length || 0) === 1 &&
  //       fileInputRefs[partId]?.current
  //     ) {
  //       fileInputRefs[partId].current.value = "";
  //     }
  //   }
  // };

  const handleFileChange = (e, partId) => {
    const files = Array.from(e.target.files).map((file, index) => ({
      file,
      id: 0,
      sequence: (videos[partId]?.length || 0) + index + 1,
    }));

    setVideos((prev) => ({
      ...prev,
      [partId]: [...(prev[partId] || []), ...files],
    }));
  };

  const handleRemoveVideo = (partId, index, id) => {
    if (id) {
      setIsModalDelete(true);
      setvideoDataId(id);
    } else {
      setVideos((prev) => {
        const updated = [...(prev[partId] || [])];
        updated.splice(index, 1);
        return { ...prev, [partId]: updated };
      });

      if (
        (videos[partId]?.length || 0) === 1 &&
        fileInputRefs.current[partId]
      ) {
        fileInputRefs.current[partId].value = "";
      }
    }
  };

  const handleEditRemoveVideo = async () => {
    let data = { id: videoDataId };

    deletePartvideo(data)
      .then((response) => {
        toast.success(response.data.message);
        setVideos((prevVideos) => {
          const updatedPartVideos = (prevVideos[partId] || []).filter(
            (video) => video.id !== videoDataId
          );

          return {
            ...prevVideos,
            [partId]: updatedPartVideos,
          };
        });
        setIsModalDelete(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setVideos((prevVideos) =>
      arrayMoveImmutable(prevVideos, oldIndex, newIndex)
    );
  };

  const handleSaveOrder = async () => {
    const sortList = videos[partId].map((video, index) => ({
      id: video.id || 0,
      sort_order: index + 1,
    }));

    try {
      await updatePartVideoSort({ sort_list: sortList });
      toast.success(t("pi_toast_sort_order_updated"));
      setIsModalOpen(false);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    }
  };
  const handleVehicleVideoSaveForm = async (e) => {
    e.preventDefault();

    const allVideos = Object.values(videos).flat();

    const newFiles = allVideos.filter((video) => video.file);

    const part_video_size = settingDetails?.part_video_size * 1024 * 1024;

    if (newFiles.length > settingDetails?.part_video_limit) {
      toast.error(
        `You can only upload up to ${settingDetails?.part_video_limit} videos.`
      );
      return;
    }

    const oversizedFiles = newFiles.filter(
      (video) => video.file.size > part_video_size
    );
    if (oversizedFiles.length > 0) {
      toast.error(
        `Each video must be under ${settingDetails?.part_video_size}MB.`
      );
      return;
    }

    if (newFiles.length === 0) {
      return;
    }

    setbtnLoading(true);
    const isEditing = !!vehicleAddDetails?.id;
    const partId = isEditing ? vehicleAddDetails?.id : currentPart?.id;

    const formData = new FormData();
    newFiles.forEach((video) => formData.append("files[]", video.file));
    formData.append("part_id", partId);

    try {
      const response = await createPartVideo(formData);

      toast.success(response.data.message);
      setPartVideoDataList(response.data.data);
      setVideos({}); // reset to empty object

      if (
        partsData?.some((part) => part.parts_damage?.length > 0) ||
        vehicleAddDetails?.parts_damage?.length > 0
      ) {
        setCurrentStep(6);
      } else {
        navigate("/parts-inventory");
      }
    } catch (err) {
      setbtnLoading(false);
      toast.error(Utils.getErrorMessage(err));
    }
  };

  const handleVehicleVideoNext = async (e) => {
    const allVideos = Object.values(videos).flat();

    const newFiles = allVideos.filter((video) => video.file);

    const part_video_size = settingDetails?.part_video_size * 1024 * 1024;

    if (newFiles.length > settingDetails?.part_video_limit) {
      toast.error(
        `You can only upload up to ${settingDetails?.part_video_limit} videos.`
      );
      return;
    }

    const oversizedFiles = newFiles.filter(
      (video) => video.file.size > part_video_size
    );
    if (oversizedFiles.length > 0) {
      toast.error(
        `Each video must be under ${settingDetails?.part_video_size}MB.`
      );
      return;
    }

    if (newFiles.length === 0) {
      return;
    }

    setbtnLoadingNext(true);
    const isEditing = !!vehicleAddDetails?.id;
    const partId = isEditing ? vehicleAddDetails?.id : currentPart?.id;

    const formData = new FormData();
    newFiles.forEach((video) => formData.append("files[]", video.file));
    formData.append("part_id", partId);

    try {
      const response = await createPartVideo(formData);

      toast.success(response.data.message);
      setPartVideoDataList(response.data.data);
      setVideos({});

      if (partsData?.some((part) => part?.parts_damage?.length > 0)) {
        setCurrentStep(6);
      } else {
        if (currentPartVideoIndex < partsData?.length - 1) {
          setCurrentPartVideoIndex((prev) => prev + 1);
        }
      }
    } catch (err) {
      setbtnLoadingNext(false);
      toast.error(Utils.getErrorMessage(err));
    }
  };

  const handleBackButtonClick = () => {
    setCurrentStep(2);
  };

  return (
    <div>
      <>
        <div className="row">
          <div className="col-lg-6">
            <Card>
              <Card.Header>
                <h6>Part Information</h6>
              </Card.Header>
              <Card.Body>
                <div className="row border-bottom py-2">
                  <div className="col-lg-6">Part Name:</div>
                  <div className="col-lg-6">
                    {currentPart?.part_name
                      ? currentPart?.part_name
                      : vehicleAddDetails?.part_name || "-"}
                  </div>
                </div>
                <div className="row border-bottom py-2">
                  <div className="col-lg-6">Part Description:</div>
                  <div className="col-lg-6">
                    {currentPart?.part_description
                      ? currentPart?.part_description
                      : vehicleAddDetails?.part_description || "-"}
                  </div>
                </div>
                <div className="row border-bottom py-2">
                  <div className="col-lg-6">Quantity:</div>
                  <div className="col-lg-6">
                    {currentPart?.quantity
                      ? currentPart?.quantity
                      : vehicleAddDetails?.quantity || "0"}
                  </div>
                </div>
                <div className="row border-bottom py-2">
                  <div className="col-lg-6">Price:</div>
                  <div className="col-lg-6">
                    €{" "}
                    {currentPart?.part_price
                      ? currentPart?.part_price
                      : vehicleAddDetails?.part_price || "0"}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          {getFieldPermission("parts_videos").show && (
            <div className="col-lg-6">
              <Card>
                <Card.Header>
                  <h6>Upload Part Videos</h6>
                </Card.Header>
                <Card.Body>
                  <input
                    type="file"
                    accept="video/*"
                    multiple
                    onChange={(e) => handleFileChange(e, partId)}
                    ref={(ref) => (fileInputRefs.current[partId] = ref)}
                    className="form-control"
                    disabled={!getFieldPermission("parts_videos").editable}
                  />

                  <div className="d-flex flex-wrap mt-3">
                    {(videos[String(partId)] || []).map((video, index) => {
                      return (
                        <>
                          <div
                            className="position-relative m-2"
                            style={{ width: "200px" }}
                          >
                            <button
                              className="btn btn-danger btn-sm position-absolute"
                              style={{
                                top: "5px",
                                right: "5px",
                                cursor: "pointer",
                                zIndex: 10,
                              }}
                              type="button"
                              onClick={() =>
                                handleRemoveVideo(partId, index, video.id)
                              }
                            >
                              ✖
                            </button>
                            <video width="200" controls>
                              <source
                                src={
                                  video.url ||
                                  (video.file &&
                                    URL.createObjectURL(video.file))
                                }
                                type="video/mp4"
                              />
                            </video>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </Card.Body>
              </Card>
            </div>
          )}
        </div>
      </>
      <div className="back-next back-next-custom">
        <div className="row" style={{ display: "none" }}>
          <div className="col">
            <button
              type="button"
              className="next-button btn btn-secondary ms-0"
              onClick={handleBackButtonClick}
            >
              <i className="bi bi-arrow-left"></i> {"back"}
            </button>
          </div>

          {/* <div className="col nxt-btn mr-0">
            {!isLastPart && (
              <Button
                className="me-2 mb-2 next-button"
                onClick={hanldeSkipOpen}
              >
                {t("skip")} & {t("next")}
              </Button>
            )}

            {!isLastPart && (
              <Button
                className="me-2 mb-2 btn-primary"
                type="button"
                onClick={handleVehicleVideoForm}
              >
                {t("save")}& {t("next")}
              </Button>
            )}

            {!isLastPart && (
              <Button
                color="primary"
                onClick={() => setIsModalOpen(true)}
                type="button"
              >
                Sort Order
              </Button>
            )}
          </div>
          {isLastPart && ( */}
        </div>

        <div className="d-flex justify-content-between mt-4">
          {currentPartVideoIndex > 0 ? (
            <button
              className="btn btn-secondary"
              onClick={() => setCurrentPartVideoIndex((prev) => prev - 1)}
            >
              Back
            </button>
          ) : (
            <Button className="btn btn-primary" onClick={handleBackVideo}>
              Back
            </Button>
          )}

          <div className="d-flex gap-2">
            {!isLastPart &&
            (!vehicleAddDetails ||
              Object.keys(vehicleAddDetails).length === 0) ? (
              <>
                <Button
                  color="primary"
                  onClick={() => setIsModalOpen(true)}
                  type="button"
                >
                  Sort Order
                </Button>
                <Button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleNext}
                >
                  Skip & Next
                </Button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleVehicleVideoNext}
                  disabled={btnLoaderNext}
                >
                  {btnLoaderNext ? "Uploading..." : "Save & Next"}
                </button>
              </>
            ) : !vehicleAddDetails ? (
              <>
                <Button
                  color="primary"
                  onClick={() => setIsModalOpen(true)}
                  type="button"
                >
                  Sort Order
                </Button>

                <button
                  type="button"
                  onClick={handleVehicleVideoSaveForm}
                  className="btn btn-primary"
                  disabled={btnLoader}
                >
                  {btnLoader ? "Uploading..." : "Save & Finish"}
                </button>

                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleFinishFinal}
                >
                  Finish
                </button>
              </>
            ) : (
              <>
                <Button
                  color="primary"
                  onClick={() => setIsModalOpen(true)}
                  type="button"
                >
                  Sort Order
                </Button>

                <button
                  type="button"
                  onClick={handleVehicleVideoSaveForm}
                  className="btn btn-primary"
                  disabled={btnLoader}
                >
                  {btnLoader ? "Uploading..." : "Save & Finish"}
                </button>

                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleFinishFinal}
                >
                  Finish
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
        <ModalHeader toggle={() => setIsModalOpen(false)}>
          Sort Videos
        </ModalHeader>
        <ModalBody>
          {videos[partId] && videos[partId].length > 0 && (
            <SortableList
              videos={videos[partId]}
              onSortEnd={({ oldIndex, newIndex }) =>
                handleSort(partId, oldIndex, newIndex)
              }
              axis="xy"
              distance={5}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSaveOrder}>
            Save Order
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isModalDelete} toggle={handleDeleteClose}>
        <ModalHeader toggle={handleDeleteClose}>Delete Video</ModalHeader>
        <ModalBody>
          <div>{"Are you sure you want to delete this video?"}</div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleDeleteClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")}
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "100px" }}
            onClick={handleEditRemoveVideo}
          >
            {t("delete")}
          </button>
        </ModalFooter>
      </Modal>{" "}
      <Modal isOpen={showSkip}>
        <ModalHeader></ModalHeader>
        <ModalBody>
          <div className="row">Are you sure you want to skip this part?</div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseSkip}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSkip}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Yes <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddPartVideo;
